import { render, staticRenderFns } from "./AccountLedger.vue?vue&type=template&id=b154423a&scoped=true&"
import script from "./AccountLedger.vue?vue&type=script&lang=js&"
export * from "./AccountLedger.vue?vue&type=script&lang=js&"
import style0 from "./AccountLedger.vue?vue&type=style&index=0&id=b154423a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b154423a",
  null
  
)

export default component.exports